export function normalizeExtension(extension, fileName = '') {
  if (extension) {
    return String(extension).toLowerCase().replace(/^\./, '')
  }

  if (fileName && fileName.includes('.')) {
    return fileName.split('.').pop().toLowerCase()
  }

  return ''
}

export function getEntityColorByExtension(extension, fileName = '') {
  const ext = normalizeExtension(extension, fileName)

  switch (ext) {
    case 'pdf':
      return 'red'
    case 'doc':
    case 'docx':
      return 'blue'
    case 'xls':
    case 'xlsx':
      return 'green'
    case 'ppt':
    case 'pptx':
      return 'orange'
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
      return 'purple'
    case 'zip':
    case 'rar':
      return 'brown'
    case 'mov':
    case 'mp4':
    case 'avi':
      return 'pink'
    default:
      return 'grey'
  }
}

export function getMaterialIconByExtension(extension, fileName = '') {
  const ext = normalizeExtension(extension, fileName)

  switch (ext) {
    case 'pdf':
      return 'mdi-file-pdf-box'
    case 'doc':
    case 'docx':
      return 'mdi-file-word'
    case 'xls':
    case 'xlsx':
      return 'mdi-file-excel'
    case 'ppt':
    case 'pptx':
      return 'mdi-file-powerpoint'
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
      return 'mdi-file-image'
    case 'zip':
    case 'rar':
      return 'mdi-file-zip'
    case 'mov':
    case 'mp4':
    case 'avi':
      return 'mdi-file-video'
    default:
      return 'mdi-file'
  }
}

export function formatFileExtension(extension, fileName = '') {
  const ext = normalizeExtension(extension, fileName)

  return ext ? ext.toUpperCase() : '—'
}
